import {httpRequest} from "./http-request";

export const unloadingsService = {
  startUnloading,
  completeUnloading,
  getUnloadingList,
  createUnloading,
  getUnloadingTime,
  cancelUnloading,
  getArchived,
};

async function startUnloading(unloadingId) {
  return await httpRequest.post(
    'unloading/start-unloading',
    {
      Id: unloadingId
    }
  ).then(
    (response) => {
      if (response.status === 200) {
        return Promise.resolve(response);
      } else {
        return Promise.reject(response);
      }
    }
  )
}

async function completeUnloading(unloadingId) {
  return await httpRequest.post(
    'unloading/complete',
    {
      Id: unloadingId
    }
  ).then(
    (response) => {
      if (response.status === 200) {
        return Promise.resolve(response);
      } else {
        return Promise.reject(response);
      }
    }
  )
}

async function cancelUnloading(unloadingId) {
  return await httpRequest.post(
    'unloading/cancel',
    {
      Id: unloadingId
    }
  ).then(
    (response) => {
      if (response.status === 200) {
        return Promise.resolve(response);
      } else {
        return Promise.reject(response);
      }
    }
  )
}

async function getArchived({limit, offset, search}) {
  return await httpRequest.post(
    'unloading/get-archived',
    {
      limit: limit,
      offset: offset,
      search: search
    }
  ).then(
    (response) => {
      if (response.status === 200) {
        return Promise.resolve(response);
      } else {
        return Promise.reject(response);
      }
    }
  )
}

async function getUnloadingList({limit, offset, search}) {
  return await httpRequest.post(
    'unloading/get-actual-list',
    {
      limit: limit,
      offset: offset,
      search: search
    }
  ).then(
    (response) => {
      if (response.status === 200) {
        return Promise.resolve(response);
      } else {
        return Promise.reject(response);
      }
    }
  )
}

async function createUnloading(data) {
  const formData = new FormData();

  for (let fieldName in data) {
    if (data.hasOwnProperty(fieldName)) {
      formData.append(fieldName, data[fieldName]);
    }
  }
  return await httpRequest.post(
    'unloading/create',
    formData
  ).then(
    (response) => {
      if (response.status === 200) {
        return Promise.resolve(response);
      } else {
        return Promise.reject(response);
      }
    }
  )
}

async function getUnloadingTime(data) {
  return await httpRequest.post(
    'unloading/get-available-time',
    {
      DistributionCenterId: data.DistCenterId,
      DateUnloading: data.DateUnloading,
      LoadingType: data.LoadingType,
      PackageType: data.PackageType,
      PalletsCount: data.PalletsCount,
      CarcassTypeId: data.CarcassTypeId,
      Weight: data.Weight,
      Volume: data.Volume
    }

  ).then(
    (response) => {
      if (response.status === 200) {
        return Promise.resolve(response);
      } else {
        return Promise.reject(response);
      }
    }
  )
}